export interface URLParams {
    protocol: string;
    host: string;
    port: string;
}

export interface SharedSessionData {
    zipcode?: number;
    city?: string;
    regionId?: number;
    centroid?: { lat: number; lon: number };
}

export interface CollectionTrackingItem {
    zpid: string;
    rec_rank: string;
}

export interface GenericCollection {
    collection_type_txt: string;
    collection_title_txt: string;
    collection_data: {
        module_rank_nb: string;
        tracing_id: string;
    };
    collection_items: CollectionTrackingItem[] | [];
}

/**
 * Placements used in Homepage defined in CMS, i.e.: https://cms-bedrock-dev.int.zgcp-consumer-nonprod-k8s.zg-int.net/krang/wp-admin/edit.php?post_type=placement
 * WARNING: Make sure Placement title in CMS matches with the enum value
 */
export enum AllHopsPlacements {
    HOME_PAGE_HERO_IMAGE = 'HomePageHeroImage',
    HOME_PAGE_RTB_CARD_1 = 'HomePageRTBCard1',
    HOME_PAGE_RTB_CARD_2 = 'HomePageRTBCard2',
    HOME_PAGE_RTB_CARD_3 = 'HomePageRTBCard3',
    HOME_PAGE_BANNER = 'HomePageBanner',
    HOME_PAGE_TOP_SLOT = 'HomePageTopSlot',
    HOME_PAGE_STICKY_SLOT = 'HomePageStickySlot',
}
